import Quill from "quill";
import { EmbedBlot } from "quill/node_modules/parchment";

////////////////////////////////////////////////////////////////////////////////

const Embed = Quill.import("blots/embed") as typeof EmbedBlot;

export default class PerformaLinkBlot extends Embed {

    static blotName = 'performaLink';
    static tagName = 'mentionLink';
    static className = 'mention';

    static create(data: any) {
        if (data.id && data.value) {
            const node: any = super.create();

            const a = document.createElement("a");
            // eslint-disable-next-line
            a.setAttribute("href", "javascript:void()");
            a.setAttribute("class", "ql-mention-link");
            //a.setAttribute("contenteditable", "false");

            a.innerHTML = data.value;

            node.appendChild(a);

            return PerformaLinkBlot.setDataValues(node, data);
        }
        return data;
    }

    static setDataValues(element: HTMLElement, data: PerformaLinkBlot) {
        const domNode = element;
        Object.keys(data).forEach((key) => {
            domNode.dataset[key] = data[key as keyof PerformaLinkBlot];
        });
        return domNode;
    }

    static value(domNode: any) {
        return domNode;
    }
}
